export const TITLE = 'title';
export const FOOTER = 'footer';
export const BODY = 'body';
export const DATE = 'date';
export const NUMBER = 'number';
